import React from "react";
import { Row } from "react-bootstrap";
import { connect } from "react-redux";
import { ActivityLogs } from "../../activityLogs";
import { GetActivityLogs } from "../action";
import { DataType } from "constant";

import moment from "moment";

import { VoucherOverviewPath } from "routes/paths";

const VoucherOverviewActivityLogFilters = Object.freeze([
  {
    key: "voucherCode",
    value: "Voucher Code",
    isDefault: true,
    dataType: DataType.String,
  },
  { key: "UserId", value: "User", dataType: DataType.String },
]);

const VoucherOverviewActivityLogs = ({ GetActivityLogs, history }) => {
  return (
    <div className="container-fluid">
      <h1>Voucher Overview</h1>
      <Row>
        <ActivityLogs
          onFetchActivityLogs={GetActivityLogs}
          onBackMainPage={() => history.push(VoucherOverviewPath)}
          activityLogFilters={VoucherOverviewActivityLogFilters}
          backButtonLabel={"View Voucher Overview"}
          extraColumns={[
            {
              dataField: "voucherCode",
              text: "Voucher Code",
              sort: true,
              style: { wordWrap: "break-word" },
              headerStyle: { wordWrap: "break-word" },
              title: (cell) => cell,
            },
          ]}
          extraSortColumns={{
            voucherCode: 1,
          }}
          detailsModalHeader={[
            {
              label: "Voucher Code",
              value: "voucherCode",
            },
            {
              label: "Activity",
              value: "activity",
            },
            {
              label: "User",
              value: "user",
            },
            {
              label: "Date",
              value: "date",
              formatter: (data) => moment(data).format("LLL"),
            },
          ]}
        />
      </Row>
    </div>
  );
};

export default connect(() => {}, { GetActivityLogs })(
  VoucherOverviewActivityLogs
);
